export class CommunicationRequestDto {
    public programId: number;
    public programName: string;
    public requestName: string;
    public requestStatus: string;
    public assetDueDate: Date;
    public reviewByDate: Date;
    public reasonForReview: {id, name, selected: boolean}[];
    public relatedTactics: {id, name, selected: boolean}[];
    public to: string[];
    public messageToBrandTeams: string;
}

export class NewCommunicationRequestDto {
    public programId: number;
    public requestName?: string;
    public dueDate?: string;
    public reasonForReviewIds?: string;
    public relatedTacticIds?: string;
    public contactIds?: string;
    public message?: string;
    public fileNames?: string;
}

export interface RequestVersion {
    versionId: number;
    displayName: string;
}

export interface FundingSource {
    fundingSource: string;
    atl: number;
    btl: number;
    total: number;
}

export interface ProgramInfo {
    programId: number;
    programName: string;
    programDescription?: any;
    jtbd?: any;
    customer: string;
    fundingSources: FundingSource[];
}

export interface Contact {
    id: number;
    name: string;
}

export interface CommunicationRequestInfo {
    currentVersionId: number;
    nextVersionId: number;
    id: number;
    requestName: string;
    requestStatus?: any;
    submittedDate: string;
    dueDate: string;
    reviewByDate: string;
    requestVersions: RequestVersion[];
    programInfo: ProgramInfo[];
    contacts: Contact[];
    reasonsForReview: {id, name, selected: boolean}[];
    relatedTactics: {id, name, selected: boolean, funding: {name: string}[], hovered: boolean}[];
}

export interface RequestFile {
    requestFileId: number;
    fileName: string;
    fileURL: string;
}

export interface MessageFile {
    fileName: string;
}

export interface RequestMessage {
    requestMessageId: number;
    createdBy: string;
    createdDate: string;
    message: string;
    messageFiles: MessageFile[];
    files: any[];
    replies: any[];
}

export interface CommunicationRequestVersion {
    id: number;
    versionId: number;
    title: string;
    requestFiles: RequestFile[];
    requestMessages: RequestMessage[];
    files: any[];
}

export class CommunicationRequestCommentDto {
    public versionId: number;
    public requestId?: number;
    public parentId: number;
    public action: string;
    public message: string;
    public sendEmail: number;
    public requestMessageId: number;
    public fileNames: string;
}
  
  export interface CustomizationMappingFields {
    programTacticId: number
    customizationRequestId: number
    customizationRequestName: string
    templateFile: string
    mappingFields: MappingField[]
  }
  
  export interface MappingField {
    documentFieldName: string
    mergeDataField: string
    exampleData: string
    parameter: string
  }


// WEBPACK FOOTER //
// ./src/app/client-core/dtos/communication-request.model.ts